export default __webpack_public_path__ + "static/media/eye.6f9fa26a.png";